// import pro1 from "../assests/project1.png"
// import pro1 from "../assests/project1.png"

import pro1 from "../assests/project1.png"
import pro2 from "../assests/project2.png"
import pro3 from "../assests/project3.png"
import pro4 from "../assests/project4.png"
import pro5 from "../assests/project5.png"
import pro6 from "../assests/project6.png"
import pro7 from "../assests/project7.png"
import pro8 from "../assests/prj8.png"


const ProjectCardData = [
    {
        imgsrc:pro1,
        title:"Movie Clone Website",
        text: "This is movie website taking data from API and build using html,css,js, react. ",
        view:"https://moviewebpage-imddapi-rating.netlify.app/",

        source:"https://github.com/AyanSrivastava11/movieWebsite-imdbAPI-rating",
    },
    {
        imgsrc:pro2,
        title:"Code Editor For Developer",
        text: "IDE for HTML, CSS, JS, this give live output when we code in it with user interface",
        view:"https://ayansrivastava11.github.io/IDE---Integrated-development-environment/",

        source:"https://github.com/AyanSrivastava11/IDE---Integrated-development-environment.git",
    },
    {
        imgsrc:pro7,
        title:"Ping-Ping game ",
        text: "It's a two-player game where each player controls a paddle to hit the ball back and forth.",
        view:"https://ayansrivastava11.github.io/ping-pong-game/",

        source:"https://github.com/AyanSrivastava11/ping-pong-game",
    },
    {
        imgsrc:pro3,
        title:"Word And Character Counter",
        text: "This project counts words and character of that he/she types. ",
        view:"https://ayansrivastava11.github.io/Word-counter/",

        source:"https://github.com/AyanSrivastava11/Word-counter.git",
    },
    {
        imgsrc:pro4,
        title:"Stop-Watch",
        text: "This is effective stop-watch with stop , start and reset features build using HTML,CSS,JS. ",
        view:"https://ayansrivastava11.github.io/Stop_watch/",

        source:"https://github.com/AyanSrivastava11/Stop_watch.git",
    },
    {
        imgsrc:pro5,
        title:"Temperature Converter",
        text: "This is used to convert temperature from fahrenheit to celcius and reverse. ",
        view:"https://ayansrivastava11.github.io/temperature-converter/",

        source:"https://github.com/AyanSrivastava11/Small-Projects.git",
    },
    {
        imgsrc:pro6,
        title:"UI/UX College Lab Exercise",
        text: "This contains my work of Photoshop and Illustrator and video making. ",
        view:"https://ayansrivastava11.github.io/Web_dev--lab_exercises/",

        source:"https://github.com/AyanSrivastava11/Web_dev--lab_exercises.git",
    },
    {
        imgsrc:pro8,
        title:"Python Project Bus Booking",
        text: "This project will book bus ticket for user and saves it data in database with generating a ticket from phone number",
        view:"https://ayansrivastava11.github.io/python_Project--Bus-Booking/",

        source:"https://github.com/AyanSrivastava11/python_Project--Bus-Booking",
    },
]

export default ProjectCardData;